import { render, staticRenderFns } from "./learning-map-browser.vue?vue&type=template&id=0964ed06&scoped=true&"
import script from "./learning-map-browser.ts?vue&type=script&lang=ts&"
export * from "./learning-map-browser.ts?vue&type=script&lang=ts&"
import style0 from "./learning-map-browser.scss?vue&type=style&index=0&id=0964ed06&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0964ed06",
  null
  
)

export default component.exports